/**
 * KVKK Aydınlatma Metni -- Screen04'teki (foto onay ekranı) "Aydınlatma metnini oku"
 * bağlantısıyla açılan scroll'lanabilir metin.
 *
 * 🚧 TASLAK / ŞABLON -- gerçek bir hukuki inceleme yerine geçmez. Köşeli parantezli
 * alanlar (`[VERİ SORUMLUSU UNVANI]` vb.) her etkinlik için o etkinliği satın alan/
 * düzenleyen FİRMANIN kendi bilgileriyle değiştirilmeden bırakılmıştır -- bilinçli
 * olarak: doldurulmadan kalırlarsa metinde çıplak gözle "[...]" olarak görünüp kendi
 * kendini ele verirler (2026-09-19, kullanıcı kararı: canlı etkinlik yokken bu haliyle
 * yayınlanması sorun değil, her etkinlik öncesi bu dosya o etkinliğin firma bilgileriyle
 * güncellenecek).
 *
 * Teknik olarak DOĞRULANMIŞ tek gerçekler bu taslağa yansıtıldı (repo'da başka bir
 * kaynak yok): fotoğraf yalnızca AI karakter/kafa üretimi için üçüncü taraf bir
 * servise (FAL AI) gönderiliyor (docs/architecture.md, run_generation.py); silme şu an
 * yalnızca misafirin kendi talebiyle çalışıyor (`DELETE /api/characters/{id}`, #94) --
 * repo'da SABİT bir otomatik saklama/silme süresi tanımlı DEĞİL, o yüzden saklama
 * süresi de bilerek köşeli parantez bırakıldı. Veri sorumlusu kimliği, iletişim bilgisi,
 * yurt dışı aktarımın hukuki dayanağı gibi alanlar tamamen etkinlik sahibi firmanın
 * kendi hukuki sorumluluğundadır -- bunlar asla tahminen doldurulmamalı.
 */
export const KVKK_AYDINLATMA_METNI: readonly string[] = [
  '1. Veri Sorumlusu: [VERİ SORUMLUSU UNVANI] ("Firma"), 6698 sayılı Kişisel Verilerin ' +
    'Korunması Kanunu ("KVKK") uyarınca "veri sorumlusu" sıfatıyla, bu etkinlik kapsamında ' +
    'elde edilen kişisel verilerinizi aşağıda açıklanan şekilde işlemektedir.',

  '2. İşlenen Kişisel Veriler: Bu uygulama kapsamında sizden yalnızca (a) fotoğrafınız ve ' +
    '(b) oyuncu adınız (rumuz/takma ad olabilir) alınır. Fotoğrafınız gerçek kimlik tespiti ' +
    'amacıyla değil, oyun içi karakterinizi oluşturmak amacıyla kullanılır.',

  '3. İşleme Amacı: Fotoğrafınız, yapay zeka destekli bir görüntü işleme hizmeti aracılığıyla ' +
    'karikatürize bir oyun karakteri görseline dönüştürülür; bu görsel yalnızca etkinlik ' +
    'kapsamındaki oyun ekranında, karakter kartınızda ve varsa maç/zafer görsellerinde ' +
    'kullanılır. Fotoğrafınız reklam, model eğitimi, pazarlama veya başka hiçbir amaçla ' +
    'kullanılmaz.',

  '4. Yapay Zeka Servis Sağlayıcısı ve Aktarım: Fotoğrafınız, görsel dönüştürme işlemi için ' +
    'üçüncü taraf bir yapay zeka servis sağlayıcısına iletilir. Bu sağlayıcının sunucuları ' +
    'yurt dışında bulunabilir; bu durumda kişisel veriniz KVKK’nın öngördüğü usul ve ' +
    'esaslara uygun şekilde yurt dışına aktarılmış olur. [YURT DIŞI AKTARIMIN HUKUKİ ' +
    'DAYANAĞI VE SERVİS SAĞLAYICI BİLGİSİ FİRMA TARAFINDAN TAMAMLANACAKTIR]',

  '5. Saklama Süresi: Fotoğrafınız ve oluşturulan karakter verileriniz [SAKLAMA SÜRESİ -- ' +
    'FİRMA TARAFINDAN BELİRLENECEKTİR] süresince saklanır. Bu süre dolmadan da, etkinlik ' +
    'kiosk ekranından karakterinizi ve ilişkili verilerinizi silme talebinde bulunabilirsiniz.',

  '6. Verilerin Paylaşımı: Kişisel verileriniz, yukarıda belirtilen yapay zeka servis ' +
    'sağlayıcısı dışında üçüncü kişilerle paylaşılmaz, satılmaz veya kiralanmaz.',

  '7. Reşit Olmayan Katılımcılar: Katılımcının 18 yaşından küçük olması hâlinde bu onay, ' +
    'katılımcının veli veya vasisi tarafından verilmelidir.',

  '8. İlgili Kişi Hakları (KVKK Madde 11): KVKK’nın 11. maddesi uyarınca; kişisel ' +
    'verinizin işlenip işlenmediğini öğrenme, işlenmişse buna ilişkin bilgi talep etme, ' +
    'işlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme, eksik veya yanlış ' +
    'işlenmişse düzeltilmesini isteme, kanunda öngörülen şartlar çerçevesinde silinmesini ya ' +
    'da yok edilmesini isteme, yapılan işlemlerin verinin aktarıldığı üçüncü kişilere ' +
    'bildirilmesini isteme, münhasıran otomatik sistemlerle analiz edilmesi sonucu aleyhinize ' +
    'bir sonuç ortaya çıkmasına itiraz etme ve kanuna aykırı işleme nedeniyle zarara ' +
    'uğramanız hâlinde bu zararın giderilmesini talep etme haklarına sahipsiniz. Bu ' +
    'haklarınızı kullanmak için [VERİ SORUMLUSU İLETİŞİM E-POSTASI / ADRESİ] üzerinden bize ' +
    'ulaşabilirsiniz.',

  '9. Onay: Bir alt satırdaki kutucuğu işaretleyerek, bu Aydınlatma Metni’ni okuduğunuzu ' +
    've fotoğrafınızın yukarıda açıklanan amaçlarla işlenmesine açık rızanız olduğunu beyan ' +
    'etmiş olursunuz.',
]
